import { store } from "~/state/store";
import { watch, watchUser } from "~/state/util";
import { fetchActiveRequests } from "~/util/providers/review";
import { ELoginState, IUserState } from "~/state/user/interfaces";
import { CONFIG } from "~/config";
import { setNotifications } from "~/state/user/state";
import { DEFAULT_USER_STATE } from "~/state/user/constants";

export interface INewEventsListResponse {
	total_new: number;
	total: number;
}

const CHECK_INTERVAL = 60 * 1000;
let interval = 0;

function clearCheckInterval() {
	if (interval) {
		window.clearInterval(interval);
		interval = null;
	}
}

async function checkNotification() {
	try {
		const response = await fetchActiveRequests(["content=dot"]);
		const data = await response.json() as INewEventsListResponse;

		if (response.status === 401) {
			throw new Error();
		} else {
			store.dispatch(setNotifications({
				total: data?.total || 0,
				totalNew: data?.total_new || 0,
			}));
		}
	} catch (ex) {
		// eslint-disable-next-line no-console
		console.log(ex);
	}
}

if (!CONFIG.inFrame) {
	const wtUser = watch(store.getState, "user", watchUser);

	store.subscribe(wtUser(async (newUser: IUserState) => {
		if (newUser.user.state === ELoginState.Green) {
			clearCheckInterval();
			await checkNotification();
			interval = window.setInterval(async () => {
				await checkNotification();
			}, CHECK_INTERVAL);
		} else {
			clearCheckInterval();
			store.dispatch(setNotifications({ ...DEFAULT_USER_STATE.notifications }));
		}
	}));
}
